<aside id="menu">
  <app-user-info-nav section="Servicer"></app-user-info-nav>
</aside>

<!--<script>
    // Initialize metsiMenu plugin to sidebar menu
    $('#side-menu').metisMenu();
</script>-->
